import { FileOutput, DonorPictureOutput } from 'gql/types';
import { getPictureUrl } from 'modules/donor/components/DonorPicturesList/utils';
import { useEffect, useState } from 'react';

export const useDonorAvatarUrl = (
  pictures?: Omit<DonorPictureOutput, 'donor'>[] | null
) => {
  const [avatarUrl, setAvatarUrl] = useState<string>();

  useEffect(() => {
    const createPictureUrl = async () => {
      if (pictures && pictures.length > 0) {
        const donorPicture =
          pictures.find(({ isPrimary }) => isPrimary) || pictures.at(0);
        const url =
          donorPicture?.file &&
          (await getPictureUrl(donorPicture?.file as FileOutput));
        url && setAvatarUrl(url);
      }
    };
    createPictureUrl();
  }, [pictures]);

  return avatarUrl;
};
